import * as Sentry from "@sentry/react";
import {
  RouterProvider,
  createRouter
} from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import "./index.scss";

import { Toaster } from "sonner";
import AuthProvider from "./lib/context/AuthContext";
import CustomDashboardProvider from "./lib/context/CustomDashboard.context";
import QueryClientProvider from "./lib/providers/QueryClientProvider";
import { routeTree } from "./routeTree.gen";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const router = createRouter({
  routeTree,
  defaultPendingMs: 0,
  defaultPreload: "intent",
  defaultPreloadDelay: 0,
});

router.subscribe("onBeforeLoad", () => {
  window.scrollTo(0, 0);
});

declare module "react" {
  export interface CSSProperties {
    [key: `--${string}`]: string | number;
  }
}

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider>
      <AuthProvider>
        <CustomDashboardProvider>
          <Toaster position="bottom-right" duration={3000} />
          <RouterProvider router={router} />
        </CustomDashboardProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
